import { render, staticRenderFns } from "./SubscriptionHistoryTable.vue?vue&type=template&id=200b978c&scoped=true"
import script from "./SubscriptionHistoryTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionHistoryTable.vue?vue&type=style&index=0&id=200b978c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b978c",
  null
  
)

export default component.exports